import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzQ0NjAyMDA2Nzg3IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEwOTAyIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZiI+PHBhdGggZD0iTTE5MiAxMjhhNjQgNjQgMCAxIDEgMCAxMjggNjQgNjQgMCAwIDEgMC0xMjh6IG0wIDMyMGE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDAgMSAwLTEyOHpNNTEyIDEyOGE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDAgMSAwLTEyOHogbTAgMzIwYTY0IDY0IDAgMSAxIDAgMTI4IDY0IDY0IDAgMCAxIDAtMTI4ek04MzIgMTI4YTY0IDY0IDAgMSAxIDAgMTI4IDY0IDY0IDAgMCAxIDAtMTI4eiBtMCAzMjBhNjQgNjQgMCAxIDEgMCAxMjggNjQgNjQgMCAwIDEgMC0xMjh6TTE5MiA3NjhhNjQgNjQgMCAxIDEgMCAxMjggNjQgNjQgMCAwIDEgMC0xMjh6IG0zMjAgMGE2NCA2NCAwIDEgMSAwIDEyOCA2NCA2NCAwIDAgMSAwLTEyOHogbTMyMCAwYTY0IDY0IDAgMSAxIDAgMTI4IDY0IDY0IDAgMCAxIDAtMTI4eiIgcC1pZD0iMTA5MDMiPjwvcGF0aD48L3N2Zz4=)
 */
export const QiehuanIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 15, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M192 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m0 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM512 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m0 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM832 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m0 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM192 768a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m320 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z m320 0a64 64 0 1 1 0 128 64 64 0 0 1 0-128z"
          fill={color}
        ></path>
      </svg>
    )
  },
)
